import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { LoginService } from "../services/login.service";
import { SetEmailRequest } from "./SetEmailRequest";

@Component({
	selector: "app-set-email-dialog",
	templateUrl: "./set-email-dialog.component.html",
	styleUrls: ["./set-email-dialog.component.css"],
})
export class SetEmailDialogComponent implements OnInit {
	constructor(
		private loginService: LoginService,
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		this.loginInfo = this.dialogConfig.data.loginInfo;
		this.TempToken2 = this.dialogConfig.data.TempToken2;

		this.UserName = this.loginInfo.userName;
	}

	//////////////////////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////////////////////
	loginInfo: any;
	TempToken2: any;

	UserName: string = "";
	NewEmail: string = "";
	ConfirmEmail: string = "";

	Processing: boolean = false;

	errorMessage: string = "";
	//////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////////////////////////////

	onUpdate() {
		this.errorMessage = "";

		if (this.NewEmail == "") {
			this.errorMessage = "Enter Email";
			return;
		}
		if (this.ConfirmEmail == "") {
			this.errorMessage = "Confirm Email";
			return;
		}
		if (String(this.NewEmail) != String(this.ConfirmEmail)) {
			this.errorMessage = "Emails don't match";
			return;
		}

		this.Processing = true;

		var parms: SetEmailRequest = {
			UserID: this.loginInfo.userID,
			Email: this.NewEmail,
		};

		var result = this.loginService.SetEmail(parms);
		result.subscribe(
			(response: any) => {
				this.Processing = false;

				if (response.Success == true) {
					//
					// Success dialog
					//
					this.confirmationService.confirm({
						key: "email",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Email was set successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.onFinish();
						},
						reject: () => {
							this.onFinish();
						},
					});
				} else {
					//
					// Fail dialog
					//
					this.confirmationService.confirm({
						key: "email",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Error updating email: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {
							return;
						},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onFinish() {
		this.ref.close(1);
	}

	//////////////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////////////
	// Helpers
	//////////////////////////////////////////////////////////////////////

	IsLoading() {
		return this.Processing == true;
	}

	//////////////////////////////////////////////////////////////////////
}
